import { css } from '@emotion/react';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

const defaultLabel = {
  cancel: i18next.t('Cancel', { ns: 'schedule' }),
  primary: i18next.t('Save', { ns: 'schedule' }),
};

type Props = {
  primaryButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  cancelButtonLabel?: string;
  primaryButtonLabel?: string;
  loading?: boolean;
  disabled?: boolean;
  onAction: () => void;
  onCancel: () => void;
};

export const PrimaryViewFooter = ({
  primaryButtonTrackingId,
  cancelButtonTrackingId,
  cancelButtonLabel = defaultLabel.cancel,
  primaryButtonLabel = defaultLabel.primary,
  loading = false,
  disabled = false,
  onAction,
  onCancel,
}: Props) => {
  return (
    <footer css={footerStyles}>
      <Button variant='secondary' trackingId={cancelButtonTrackingId} onClick={onCancel}>
        {cancelButtonLabel}
      </Button>
      <Button disabled={disabled} loading={loading} trackingId={primaryButtonTrackingId} onClick={onAction}>
        {primaryButtonLabel}
      </Button>
    </footer>
  );
};

const footerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2, 2, 2),
  button: { flex: 1 },
});
